import { combineLatest, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
class ConnectedCreator {
}
/**
 * DefaultConnectedStrategy determines if the track is in a connected state
 * by examning if a given video track is defined or not
 */
export class DefaultConnectedStrategy extends ConnectedCreator {
    constructor(track) {
        super();
        this.track = track;
    }
    createConnected() {
        return this.track.pipe(map(track => !!track));
    }
}
/**
 * NameConnectedStrategy determines if the track is in a connected state
 * by examining if a VideoTrack WallItem and a VideoTrack have the same name
 */
export class NameConnectedStrategy extends ConnectedCreator {
    constructor(wallItem, track) {
        super();
        this.wallItem = wallItem;
        this.track = track;
    }
    createConnected() {
        return combineLatest([this.wallItem, this.track]).pipe(switchMap(([item, track]) => {
            if (!item || !track) {
                return of(false);
            }
            if (!item.name || !track.name) {
                return of(false);
            }
            return of(track.name === item.name);
        }));
    }
}
//# sourceMappingURL=connected_strategy.js.map